module.exports = __webpack_public_path__ + "img/lock.7cca98c3.svg";